
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error("Supabase Error: Missing environment variables in .env.local!");
  console.error("REACT_APP_SUPABASE_URL:", supabaseUrl);
  console.error("REACT_APP_SUPABASE_ANON_KEY:", supabaseAnonKey);
}

export const supabase = createClient(
  supabaseUrl || "https://placeholder.supabase.co",
  supabaseAnonKey || "placeholder-key",
  {
    auth: {
      storage: window.sessionStorage, // Session is cleared automatically on tab/browser close
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
  }
);